import { render, staticRenderFns } from "./arrow-right.mpx?vue&type=template&id=07f8d01a&component=true&componentId=arrow-right75d32029"
import script from "./arrow-right.mpx?vue&type=script&lang=js&component=true&componentId=arrow-right75d32029"
export * from "./arrow-right.mpx?vue&type=script&lang=js&component=true&componentId=arrow-right75d32029"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports